/* eslint-disable react/no-string-refs */
import * as React from 'react';
import Text from '../../../shared/Text';
import C42Icon from '@c42/ui/lib/svg-icons/c42-icon';
import Tooltip from '@c42/ui/lib/tooltip';
import classNames from 'classnames';

interface Props {
  isFormDisabled: boolean;
  onChangeTotp: () => void;
  resetForm: () => void;
  submitForm: () => void;
  totp: string;
}

interface State {
  isTotpEmpty: boolean;
}

export default class LoginStepTotpConfig extends React.Component<Props, State> {
  constructor() {
    super();
    this.state = {
      isTotpEmpty: false,
    };
  }

  submitForm = (e: React.FormEvent<any>) => {
    if (e && 'preventDefault' in e) {
      e.preventDefault();
    }
    const { submitForm, totp } = this.props;
    if (totp === null || totp === '') {
      this.setState({ isTotpEmpty: true });
      return;
    }
    if (typeof submitForm === 'function') {
      submitForm();
    }
  };

  resetForm = (e: React.MouseEvent<any>) => {
    if (e && 'preventDefault' in e) {
      e.preventDefault();
    }
    if (typeof this.props.resetForm === 'function') {
      this.props.resetForm();
    }
  };

  changeTotp = (e: React.FormEvent<any>) => {
    this.setState({ isTotpEmpty: false });
    this.props.onChangeTotp.call(null, e);
  };

  showTooltip = (e) => {
    e.target = e.currentTarget;
    const tooltip: any = this.refs.tooltip;
    tooltip.showTooltip(e);
  };

  hideTooltip = () => {
    const tooltip: any = this.refs.tooltip;
    tooltip.hideTooltip();
  };

  render() {
    const { isFormDisabled } = this.props;

    const { isTotpEmpty } = this.state;

    const tooltipEventProps = {
      onFocus: this.showTooltip,
      onBlur: this.hideTooltip,
      onMouseOver: this.showTooltip,
      onMouseOut: this.hideTooltip,
    };

    return (
      <form
        className="step-totp-code"
        data-test="login-form"
        name="loginFrm"
        noValidate
        onSubmit={this.submitForm}
      >
        <div className="form-control-wrapper">
          <p className="totp-code-description">
            <span>{Text.get('login_totp_code_description')}</span>
            <span className="totp-info-icon" tabIndex={0} {...tooltipEventProps}>
              <C42Icon icon="info" />
            </span>
            <Tooltip effect="solid" place="right" ref="tooltip">
              {Text.get('login_totp_code_tooltip')}
            </Tooltip>
          </p>
        </div>
        <div className="form-control-wrapper totp-input-wrapper">
          <input
            autoFocus
            type="text"
            maxLength={6}
            className={classNames('totp-input', { errored: isTotpEmpty })}
            data-test="totp-code"
            disabled={isFormDisabled}
            onChange={this.changeTotp}
          />
          {isTotpEmpty && (
            <p className="totp-verify-error totp-helper-text">{Text.get('login_totp_code_required')}</p>
          )}
        </div>
        <div className="form-control-wrapper submit">
          <input
            type="submit"
            data-test="submit"
            disabled={isFormDisabled}
            value={Text.get('login_button_sign_in')}
            className="btn btn-default btn-flat btn-customizable c42-orange c42-button"
          />
        </div>
        <div className="form-control-wrapper link">
          <a href="#" onClick={this.resetForm} data-test="signin-different-account">
            {Text.get('sso_signin_different_account')}
          </a>
        </div>
      </form>
    );
  }
}
